<app-input-filter [filter]="filter" [dataToView]="dataToView"></app-input-filter>
